import { createApp } from 'vue';
import router from './router';
import App from './App.vue';
import store from './store'; // Adjust the path if necessary

const app = createApp(App);

app.use(router);
app.use(store);

// Fetch user data from localStorage and set it in Vuex store
const token = localStorage.getItem('token');
const user = localStorage.getItem('user');
if (token && user) {
  store.commit('setToken', token);
  store.commit('setUser', JSON.parse(user));
}

router.beforeEach((to, from, next) => {
  // Check if the route requires authentication and the user is not logged in
  if (to.matched.some(record => record.meta.requiresAuth) && !store.state.token) {
    next({ name: 'Login' }); // Redirect to login if not logged in
  } else {
    next(); // Continue to the next route
  }
});

// Mount the app
app.mount('#app');
